import { useState, useCallback } from 'react';

type Entry<T> = { id: string; value: T };

export const useEntries = <T>() => {
  const [entries, setEntries] = useState<Entry<T>[]>([]);

  const removeEntry = useCallback((id: string) => {
    setEntries(prev => prev.filter(entry => entry.id !== id));
  }, []);

  const addEntry = useCallback(
    (value: T) => {
      const id = crypto.randomUUID();
      setEntries(prev => [...prev, { id, value }]);
      return () => removeEntry(id);
    },
    [removeEntry]
  );

  return [entries, addEntry, removeEntry] as const;
};
